module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Location-arrow-8bfee36e44eaffb289645e5b55b0e565.svg";